import { motion } from "motion/react";
import { Terminal, Code2, Network, CircuitBoard, Database } from "lucide-react";
import { useTranslation } from "react-i18next";

const TECHNOLOGIES = [
  { name: "Golang", icon: <Terminal className="w-8 h-8" /> },
  { name: "React", icon: <Code2 className="w-8 h-8" /> },
  { name: "NATS", icon: <Network className="w-8 h-8" /> },
  { name: "MCP", icon: <CircuitBoard className="w-8 h-8" /> },
  { name: "PostgreSQL", icon: <Database className="w-8 h-8" /> },
] as const;

export default function TechStack() {
  const { t } = useTranslation();

  return (
    <section id="tech-stack" className="py-24 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col items-center mb-16 text-center">
          <span className="text-[12px] font-bold text-primary-container tracking-widest mb-2 uppercase">{t('tech_stack.badge')}</span>
          <h2 className="text-3xl font-bold text-on-surface">{t('tech_stack.title')}</h2>
        </div>
        
        <motion.div 
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="flex flex-wrap justify-center gap-12"
        >
          {TECHNOLOGIES.map((tech) => (
            <div key={tech.name} className="flex flex-col items-center gap-3 opacity-60 hover:opacity-100 transition-opacity group">
              <div className="w-16 h-16 bg-white rounded-lg flex items-center justify-center border border-outline-variant group-hover:border-primary-container group-hover:text-primary-container transition-all">
                {tech.icon}
              </div>
              <span className="font-bold text-sm">{tech.name}</span>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}